import { createMutationAtom } from 'atoms/create-resource-atom';
import { createResourceAtom } from 'lib/atoms';
import {
  VerificationItemCommentResponse,
  VerificationItemEventResponse,
} from 'types/api-responses';

export const createVerificationItemEventsAtom = (eventsHref: string) =>
  createResourceAtom<VerificationItemEventResponse[]>(eventsHref);

export const verificationItemEventMutationAtom = createMutationAtom<
  VerificationItemEventResponse,
  'verificationItemEvent'
>();

export const verificationItemCommentMutationAtom = createMutationAtom<
  VerificationItemCommentResponse,
  'verificationItemComment'
>();
